const PDF_PAGE = {
  WIDTH: '420',
  HEIGHT: '595',
};

module.exports = PDF_PAGE;
